var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<div class=\"notification\">\n  <p class=\"notification__description\">We recently checked with the manufacturer and unfortunately, this size is not available for special order. If you're still interested in the product, we can notify you by email if this size comes back.</p>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/product-notifications/unavailable.html
// module id = 167
// module chunks = 0